// Use service layer instead of direct Firestore access
import { isEmailUnique as isEmailUniqueService } from '../services/patientService';

export const isEmailUnique = async (email, currentPatientId = null) => {
  if (!email) return true;
  
  try {
    // Use the service layer instead of direct Firestore access
    const result = await isEmailUniqueService(email, currentPatientId);
    console.log('Email uniqueness check result:', { email, currentPatientId, isUnique: result });
    return result;
  } catch (error) {
    console.error('Error checking email uniqueness:', error);
    // Return true on error to allow the operation to proceed
    return true;
  }
};